/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */



// dependencies - jquery ui datepicker
var event_collection = new function(){
  var self = this;
  var dates = [];

  var lookup = {
    "Jan": "1",
    "Feb": "2",
    "Mar": "3",
    "Apr": "4",
    "May": "5",
    "Jun": "6",
    "Jul": "7",
    "Aug": "8",
    "Sep": "9",
    "Oct": "10",
    "Nov": "11",
    "Dec": "12"  
  };
  
  this.highlightDays = function(date) {
      for (var i = 0; i < dates.length; i++) {

          var cd = dates[i].date.split('-');
          d = [ String(date.getFullYear()), String(date.getMonth() + 1), String(date.getDate()) ];
        
          if(cd[0] == d[0] && lookup[cd[1]] == d[1] && cd[2] == d[2]){
          	console.log(dates[i].date, date);
          	console.log(cd[0], d[0], lookup[cd[1]], d[1], cd[2], d[2]);
			return [true, '', dates[i].title];
          }
      }
 
      return [false, '', 'unAvailable'];
  }
  
  this.nth = function(d) {
    if (d > 3 && d < 21) return 'th'; 
    switch (d % 10) {
      case 1:  return "st";
      case 2:  return "nd";
      case 3:  return "rd";
      default: return "th";
    }
  }
  
  this.onDateSelect = function(date) {
    console.log('onselect');
    $($(this).attr('other')).datepicker('setDate', date);
	
    let tag = date.toString().replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3-$1-$2");
    
    var d = new Date(date.toString().replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3-$1-$2"));
    
    const monthNames = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    
    var dateString = 'CLASSES ON THE ' + d.getDate() + self.nth(d.getDate()) + ' of ' + monthNames[d.getMonth()];
    
    $('.sm-event-filter-header').text(dateString);
    $('.sm-header-bar').addClass('active');
    
    $('.sm-event-container').each(function(){
      if($(this).attr('date') == tag){
        $(this).show();
      }else{
        $(this).hide();
      }
    })
  }
  
  this.clear_date = function(){
    $('#datepicker').datepicker('setDate', null);
	$('#datepicker--mobile').datepicker('setDate', null);
    $('.sm-event-container').show();
    $('.sm-header-bar').removeClass('active');
  }
  
  this.page = function(){
    var rt = $(this).closest('.date-picker-containter');
    var sel = ($(this).hasClass('month-next') ? '.ui-datepicker-next' : '.ui-datepicker-prev');
    rt.find(sel).first().trigger('click');

    if( rt.find('.ui-datepicker-next').hasClass('ui-state-disabled') ){
      rt.find('.month-next').removeClass('active');
    }else{
      rt.find('.month-next').addClass('active');
    }
    
    if( rt.find('.ui-datepicker-prev').hasClass('ui-state-disabled') ){
      rt.find('.month-prev').removeClass('active');
    }else{
      rt.find('.month-prev').addClass('active');
    }
  }

  
  this.init = function(){
    console.log('EVENT INIT');
    $('.date-data').each(function(){
	  var title = $(this).closest('.sm-event-details').find('.sm-event-title').text();
      //console.log(title);
      title = (typeof title === "undefined" || !title ? "Available" : title);
      dates.push({date: $(this).attr('date'), title: title});
    });
    let options = { 
      numberOfMonths: 2,
      minDate: new Date(),
      beforeShowDay: self.highlightDays,
      onSelect: self.onDateSelect
    };
  	$('#datepicker').datepicker(options);
    options['numberOfMonths'] = 1;
    $('#datepicker--mobile').datepicker(options);
    
    $('.page-alias').on('click', self.page);
    
    $('.sm-event-clear-date').on('click', self.clear_date);
  }
}

$(event_collection.init);



var product_page = new function(){
  var self = this;
  
  this.show_more = function(){
	var rt = $(this).closest('.sm-expandible');
    rt.removeClass('sm-expandible');
    rt.find('.description-see-more').remove();
  }
  
  this.next_image = function(){
    //console.log('move');
    var curr = $('.flickity-page-dots .dot.is-selected');
    if(curr.is(':last-child')){
      $('.flickity-page-dots .dot:first-child').trigger('click');
    }else{
      curr.next().trigger('click');
    }
  }
  
  this.prev_image = function(){
    //console.log('move');
    var curr = $('.flickity-page-dots .dot.is-selected');
    if(curr.is(':first-child')){
      $('.flickity-page-dots .dot:last-child').trigger('click');
    }else{
      curr.prev().trigger('click');
    }
  }
  
  
  this.scroll_to_delivery = function(){

	var rt = $("button.Collapsible__Button.sm-delivery-returns");
	var offset = $('header#section-header').outerHeight();
    //console.log('height', offset);
    
    if(rt.attr('aria-expanded') == "false"){
        offset += $('.Collapsible__Button[aria-expanded="true"]').closest('.Collapsible').find('.Collapsible__Inner').outerHeight();;
    	rt.click();
    }
    
  	$([document.documentElement, document.body]).animate({
        scrollTop: rt.offset().top - offset
    }, 200);
  }
  
  this.get_spec_extra = function(){
    var ret = {};
    $('.ProductForm__Option--labelled').each(function(){
      ret[$(this).find('.ProductForm__Label').text().trim().slice(0, -1)] = $(this).find('input:checked').val()
    });
	return ret;
    //console.log(ret);
  }
  
  this.update_sku_view = function(){
    
    setTimeout(function(){
      var id = $("select[name='id'] option[selected]").attr('value');
      $('.sku-view').each(function(){
        $(this).removeClass('active');
      });
      $('.sku-view[data-variant-id="'+id+'"]').addClass('active');
      
      

	  var spec_extra = self.get_spec_extra();
      for(var key in spec_extra){
        $('.product-specification-table .spec-extra[data-label="'+key+'"]').text(spec_extra[key]);
      }
    }, 50);
    
  }
  
  this.init_specs = function(){
    var table = $('.product-specification-table');
    if(table.length){
      var spec_extra = self.get_spec_extra();
		//console.log(spec_extra);
      for(var key in spec_extra){
       	 table.find('tbody').append('\
            <tr>\
              <th class="label">'+key+'</th>\
              <td class="data spec-extra" data-label="'+key+'">'+spec_extra[key]+'</td>\
            </tr>\
		  ');
      }
    }
  }
  
  this.init = function(){
  	$('.description-see-more button').on('click', self.show_more);
    $('.sm-image-right').on('click', self.next_image);
    $('.sm-image-left').on('click', self.prev_image);
    $('.sm-scroll_to_delivery').on('click', self.scroll_to_delivery);
    self.init_specs();
    $('.HorizontalList__Item').on('change', self.update_sku_view);

    
  }
}

$(product_page.init);


var headerPop = new function(){
  var self = this;
  this.scrollTrigger = 100;
  this.lastPos = 0;
  this.upCount = 0;
  this.downCount = 0;
  this.hideThresh = 80;
  this.navSel = '.shopify-section--header';
  this.hiddenClass = 'pt-mobile-hidden';
  this.skip = 40;
    
  
  this.init = function(){
    
    //console.log('init');
	$(window).on('scroll', function () {
      if(self.skip-- > 0){ return; }
      var scrollTop = $(window).scrollTop();
      
      if (scrollTop > self.scrollTrigger && self.upCount > self.hideThresh && !$(self.navSel).hasClass(self.hiddenClass)) {
        $(self.navSel).addClass(self.hiddenClass);
      } else if((self.downCount > self.hideThresh || scrollTop < self.scrollTrigger) && $(self.navSel).hasClass(self.hiddenClass)) {
        $(self.navSel).removeClass(self.hiddenClass);
      }


      if(self.lastPos > scrollTop){
        self.downCount += self.lastPos - scrollTop;
        self.upCount = 0;
      }else if(self.lastPos < scrollTop){
        self.upCount += scrollTop - self.lastPos;
        self.downCount = 0;
      }
	  self.lastPos = scrollTop;
	 
    });

  }  
}

$(headerPop.init);


$(function(){
	$('.HorizontalList__Item').on('click', function(){
      setTimeout(function(){

        var id = $("select[name='id'] option[selected]").attr('value');

        $('.sku-view').each(function(){
            $(this).removeClass('active');
        });

        $('.sku-view[data-variant-id="'+id+'"]').addClass('active');

      }, 50);
    });


    $('.Popover__Value').on('click', function(){
		setTimeout(function(){

        var id = $("select[name='id'] option[selected]").attr('value');
        //console.log(id);

        $('.sm-product-event-tags').each(function(){
            $(this).removeClass('active');
        });

        $('.sm-product-event-tags[data-variant-id="'+id+'"]').addClass('active');
          
          
        if($('.sm-product-event-tags.active .fa-exclamation-triangle').length){
          //console.log('show');
          $('#zooomybackinstock').show();
        }else{
          //console.log('hide');
          $('#zooomybackinstock').hide();
        }
          

      }, 50);
    });
  
  	
});


/*********
	Smoothie Carousel - sections/slideshow-smoothie.liquid
	Made by Smoothie Web Design Ltd.
**********/

var ss = new function(){
  var self = this;
  this.speed = 300;

  this.transition = function(next, curr){
    next.attr('style', 'display: block; position: relative;');
    curr.attr('style', 'position: absolute; top: 0px; right: 0px; left: 0px;');
    curr.fadeOut(self.speed, function(){
      $(next).addClass('active');
      $(curr).removeClass('active');
      next.attr('style', '');
      curr.attr('style', '');
    });
  }

  this.prev = function(){
    var rt = $(this).closest('.sm-slideshow');
    var count = rt.find('.sm-slide').length;
    var curr = rt.find('.sm-slide.active');
    var idx = parseInt(curr.attr('data-index'));
    var next = rt.find('.sm-slide[data-index="'+(idx <= 1 ? count : idx - 1)+'"]');
    self.transition(next, curr);
  }

  this.next = function(){
    var rt = $(this).closest('.sm-slideshow');
    var count = rt.find('.sm-slide').length;
    var curr = rt.find('.sm-slide.active');
    var idx = parseInt(curr.attr('data-index'));
    var next = rt.find('.sm-slide[data-index="'+(idx >= count ? 1 : idx + 1)+'"]');
    self.transition(next, curr);
  }

  this.lazy = function(obj){
    //console.log('lazy loaded');
    var rt = $(obj).closest('.sm-slideshow');

    if($(obj).hasClass('sm-desktop')){
      rt.find('.sm-desktop').each(function(){
        $(this).attr('onload', '').attr('src', $(this).attr('data-src')).removeClass('lazyload');
      });
    }

    if($(obj).hasClass('sm-mobile')){
      rt.find('.sm-mobile').each(function(){
        $(this).attr('onload', '').attr('src', $(this).attr('data-src')).removeClass('lazyload');
      });
    }
  }

  this.init = function(){

    //console.log('sinits');
    $('.sm-slideshow.sm-active-sliding').on('swipeleft', self.next);
    $('.sm-slideshow.sm-active-sliding').on('swiperight', self.prev);
    $('.sm-action-left').on('click', self.prev);
    $('.sm-action-right').on('click', self.next);
    
    setInterval(function(){
     // console.log('here');
    	$('.sm-action-left').trigger('click');
    }, 5000);
  }
}

$(ss.init);

$(function(){
  $('#hide-cookery-signup').on('click', function(){
  	$('#cooking-signup').hide();
    Cookies.set('cooking', 'hidden');
  });
  
  $('.subscribe-open').on('click', function(){
	var target = $(this).attr('data-target');
    $(target).show();
    Cookies.set('cooking', 'visible');
  });
  
  if(Cookies.get('cooking') == "hidden"){
    $('#cooking-signup').hide();
  }
})


var test = new function(){
  var self = this;


  this.init = function(){
  	ga('send', 'event', 'addtobasket', '');
  }
}

$(function(){
  $('.sm-search-mobile').on('click', function(){
    $('.sm-search').addClass("active");
  });
  
  $('.sm-search-close').on('click', function(){
    $('.sm-search').removeClass("active");
  });
  
});


